import React, { type ReactNode } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';

type RelayLayoutItemErrorBoundaryProps = {
	children?: ReactNode;
	itemName: string | undefined;
};

const renderContent = () => <></>;

export const RelayLayoutItemErrorBoundary = ({
	children,
	itemName,
}: RelayLayoutItemErrorBoundaryProps) => (
	<JSErrorBoundary
		id={`${itemName}-relay-layout-item`}
		packageName="jiraIssueView"
		teamName="bento"
		render={renderContent}
	>
		{children}
	</JSErrorBoundary>
);
